import definition from './definition';
import schema from './schema';
import defaults from './defaults';

export default {
  definition,
  schema,
  defaults
};
